import { render, staticRenderFns } from "./SMClassList.vue?vue&type=template&id=5520306a"
import script from "./SMClassList.vue?vue&type=script&lang=js"
export * from "./SMClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports